import { useCallback, useContext } from "react";
import { DataContext } from "../contexts/DataProvider";
import { AlertColor } from "@mui/material";

export const useAlert = () => {
  const { setSnackbar, snackbar } = useContext(DataContext);

  const setAlert = useCallback(
    (message: string, alert: AlertColor = "error", duration: number = 3000) => {
      setSnackbar({ open: true, message, alert });
      setTimeout(() => {
        setSnackbar({ open: false, message: "", alert });
      }, duration);
    },
    [setSnackbar]
  );

  return [setAlert, snackbar];
};
